import {
    graphql
} from 'react-relay'






const query = graphql`
    query getSupplierQuery($id: String!) {
        getSupplier (id: $id){
            id, 
            name, 
            createdAt, 
            updatedAt
      }
    }
  `

export default query;